/**
 * Extend core form-mini.js to add search overlay when screen size is tablet and mobile
 **/
define([
    'jquery'
],
($) => {
    return function (widget) {
        $.widget('mage.quickSearch', widget, {

              options: {
                    searchOverlay : '.search.overlay'
              },

            /**
             * Search set to blur on clicking on search overlay
             * @private
             * @override
             */
            _create: function () {
                this._super();
                this.searchOverlay = $(this.options.searchOverlay);
                this.searchOverlay.on('click' , ()=>$(this.element).trigger('blur'));
                
                // the previous hack was to have the input be 1x1 in size with 0 opacity,
                // then when the search icon label which is only visible on tablet is clicked,
                // it would actually be that the user is clicking the "invisible 1x1pixel" input,
                // which would then fire the focus handler on the parent; 
                // its better to hide the input and listen for clicks on the search button.
                const mySearchIcon = $('[data-role=minisearch-label]');
                mySearchIcon.on('click', () => {
                    this.setActiveState(true);
                });
            },

            /**
             * Sets active state for search overlay
             *
             * @param {Boolean} isActive
             * @override
             */
            setActiveState: function (isActive) {
                this._super(isActive);
                $("body").toggleClass('search-overlay-active', isActive);
            },

            /**
             * Do nothing when input change as we don't use Magento search suggestion
             *
             * @private
             * @override
             */
            _onPropertyChange: function () {
                return null;
            }
        });

        return $.mage.quickSearch;
    };
});
